import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';


export const routes: Routes = [
  { 
    path: 'cms',     
    canActivate: [MsalGuard],
    loadChildren: () => import('./cms/cms.routes').then(r => r.CMS_ROUTES)    
  },
  { 
    path: '', 
    loadChildren: () => import('./website/website.routes').then(r => r.WEBSITE_ROUTES)
  },
];